<template>
    <div class="agenda-wrap">
        <agenda-general-settings />
        <agenda-create-edit-session
            v-bind="sharedProps"
            :agendaCurrent="agendaCurrent"
            :isOpen="isCreateEditSessionOpen"
            @cancel-edit="agendaCurrent={}"
            @set-is-open="isCreateEditSessionOpen = $event"
            @get-agendas="getAgendas"
            @get-companies="getCompanies"
            @get-users="getUsers"
        />
        <agenda-list-of-sessions
            v-bind="sharedProps"
            @clone-agenda="cloneAgenda"
            @set-current-agenda="setCurrentAgenda"
            @confirm-delete="confirmDelete"
            @change-timezone="selectedTimezoneOffset = $event"
            @get-agendas="getAgendas"
            @upload-pdf="uploadPdf"
            @set-selected-agendas="setSelectedAgendas"
            @bulk-action="handleBulkAction"
        />
    </div>
</template>

<script>
import AgendaGeneralSettings from '@/components/admin/agenda/AgendaGeneralSettings.vue';
import AgendaCreateEditSession from '@/components/admin/agenda/AgendaCreateEditSession.vue';
import AgendaListOfSessions from '@/components/admin/agenda/AgendaListOfSessions.vue';
import AdminMixin from '@/views/admin-pages/adminMixin';
import api from "@/api";
import moment from "moment";
export default {
    mixins: [
        AdminMixin,
    ],
    components: {
        AgendaGeneralSettings,
        AgendaCreateEditSession,
        AgendaListOfSessions,
    },
    data () {
        return {
            selectedTimezoneOffset: -new Date().getTimezoneOffset() / 60,
            // allDays: [],
            locations: [],
            users: [],
            // bulkActions: [],
            agendas: [],
            companies: [],
            tags: [],
            types: [],
            // agenda that is currently being edited
            agendaCurrent: {},
            // single delete
            agendaIdToDelete: null,
            // selected agendas from table
            selectedAgendas: [],
            isCreateEditSessionOpen: false,
        };
    },
    computed: {
        sharedProps () {
            return {
                agendas: this.agendas,
                locations: this.locations,
                types: this.types,
                users: this.users,
                companies: this.companies,
                tags: this.tags,
                selectedTimezoneOffset: this.selectedTimezoneOffset
            }
        },
    },
    watch: {
        selectedTimezoneOffset: {
            handler () {
                this.init();
            },
        }
    },
    mounted () {
        this.init();
        this.timeoutId = setInterval(() => {
            this.updateDisplayTime();
        }, 1000);
    },
    beforeDestroy () {
        if (this.timeoutId) {
            clearInterval(this.timeoutId);
            this.timeoutId = null;
        }
    },
    methods: {
        async init () {
            this.startLoading();
                await this.getAgendas();
                await this.getAgendaLocations();
                this.getTypes();
                this.getCompanies();
                this.getUsers();
                this.getTags();
            this.stopLoading();
        },
        async getAgendas (searchParams = {}) {
            const apiObj = {
                api: api.getAllAgendas,
                onError: () => this.stopLoading(),
            }

            if (Object.keys(searchParams).length > 0) {
                apiObj.params = {
                    filter: searchParams,
                };
            }

            const data = await this.apiCall(apiObj);
            if (data.data !== undefined) {
                this.agendas = data.data.map(agenda => {
                    const isAgendaSelected = this.selectedAgendas.findIndex(selAgn => agenda.agn_id === selAgn.agn_id) !== -1;
                    agenda.selected = isAgendaSelected;
                    return agenda;
                });
                this.updateAgendaDateTimes();
                /* New - sort agendas by name asc */
                // this.agendas.sort( this.compare );
            } else {
                this.agendas = [];
            }
        },
        /* Custom objects array sort function */
        compare( a, b ) {
            if ( a.agn_name.toLowerCase() < b.agn_name.toLowerCase() ){
                return -1;
            }
            if ( a.agn_name.toLowerCase() > b.agn_name.toLowerCase() ){
                return 1;
            }
            
            return 0;
        },
        updateAgendaDateTimes () {
            for (let i = 0; i < this.agendas.length; i++) {
                this.agendas[i].agn_to = this.convertStringToTimezone(
                    this.agendas[i].agn_to,
                    this.selectedTimezoneOffset
                );
                this.agendas[i].agn_from = this.convertStringToTimezone(
                    this.agendas[i].agn_from,
                    this.selectedTimezoneOffset
                );
            }
        },
        updateDisplayTime () {
            this.displayTime = this.convertStringToTimezone(
                moment().utc().format("YYYY-MM-DD HH:mm:ss"),
                this.selectedTimezoneOffset
            );
        },
        async getAgendaLocations () {
            let apiObj = {
                api: api.getAgendaLocations,
                onError: () => this.stopLoading()
            }
            const data = await this.apiCall(apiObj);
            this.locations = data.result;
        },
        async getCompanies(search = "") {
            try {
                let res = await api.getCompanies({ search: search });
                this.companies = res.data.result;
            } catch (e) {
                console.warn(e);
            }
        },
        async getTypes() {
            try {
                let res = await api.getAgendaTypes();
                this.types = res.data.result;
            } catch (e) {
                console.warn(e);
            }
        },
        async getUsers (search = "") {
            let res;
            try {
                res = await api.getUsers({
                    search: search,
                    limit: 999,
                    offset: 0,
                });
                this.users = res.data.result || [];
            } catch (error) {
                console.warn(error);
            }
        },
        async getTags() {
            let res;
            try {
                res = await api.getTags();
                this.tags = res.data.result;
            } catch (error) {
                console.warn(error);
            }
        },
        convertStringToTimezone (datetime, offsetHours) {
            offsetHours = parseInt(offsetHours);
            let tempMoment = moment(datetime);
            tempMoment.add(offsetHours, "hours");
            return moment(tempMoment, "YYYY-MM-DD HH:mm:ss").format('DD.MM.YYYY HH:mm');
        },
        confirmDelete (agnId) {
            this.agendaIdToDelete = agnId;
            this.confirmAction(this.deleteAgenda, this.$t('adminAgenda.agendaDeleteQuestion'), 'Delete', () => this.agendaIdToDelete = null);
        },
        handleBulkAction (action) {
            if (action === 'Delete') this.confirmAction(this.deleteAgenda, this.$t('adminAgenda.agendaDeleteSelected'));
        },
        setSelectedAgendas (agendaIdArray) {
            this.selectedAgendas = agendaIdArray;
        },
        async deleteAgenda () {
            let agn_ids;
            if (this.agendaIdToDelete) agn_ids = [this.agendaIdToDelete];
            else agn_ids = this.selectedAgendas.map(agn => agn.agn_id);

            const apiObj = {
                api: api.deleteAgenda,
                params: {
                    agn_id: agn_ids,
                },
                onError: () => this.stopLoading()
            }
            this.startLoading();
                if (await this.apiCall(apiObj)) {
                    this.showSuccessMessage(this.$t('adminAgenda.agendaDeleted'));
                    this.agendaCurrent = {};
                    this.agendaIdToDelete = null;
                    await this.getAgendas();
                }
            this.stopLoading();
        },
        async setCurrentAgenda (agenda) {
            this.isCreateEditSessionOpen = true;
            await this.$nextTick();
            this.agendaCurrent = agenda;
        },
        async cloneAgenda (agenda) {
            const apiObj = {
                api: api.createAgenda,
                params: {
                    ...agenda,
                },
                onError: () => this.stopLoading(),
            };
            if (agenda.tags_ids) {
                // string received, array of numbers created
                apiObj.params.agn_tags = agenda.tags_ids.split(',').map(stringId => Number(stringId));
            }

            this.startLoading();
            if (await this.apiCall(apiObj)) {
                this.showSuccessMessage('Agenda cloned.');
                await this.getAgendas();
            }
            this.stopLoading();
        },
        async uploadPdf (pdf) {
            this.startLoading();
                const formData = new FormData();
                formData.append('pdf', pdf);

                const apiObj = {
                    api: api.uploadPdf,
                    params: formData,
                    onError: () => this.stopLoading()
                }
                if (await this.apiCall(apiObj)) {
                    this.showSuccessMessage(this.$t('adminAgenda.pdfUploaded'));
                }
            this.stopLoading();
        },
    }
};
</script>

<style lang="scss" scoped>
.agenda-wrap {
    padding: 2em;
}
</style>